import { isEmpty } from 'lodash-es';
import React, { useCallback } from 'react';

import { useDebouncedCallback } from '../../utils/hooks/useDebounce';
import { type SearchFiltersVariables } from '../../utils/search';
import SearchBar from '../common/SearchBar';

interface SRPSearchBarProps {
  className?: string;
  inputContainerClassName?: string;
  value: Possible<string>;
  placeholder?: string;
  setSearchVariables: React.Dispatch<
    React.SetStateAction<SearchFiltersVariables>
  >;
  onChange?: (keyword: Nullable<string>) => void;
  onFocus?: () => void;
}

const SRPSearchBar: React.FC<SRPSearchBarProps> = ({
  className = '',
  inputContainerClassName = '',
  value,
  placeholder = 'Search',
  setSearchVariables,
  onChange,
  onFocus,
}) => {
  const setSearchVariablesCallback = useCallback(
    (input: string) => {
      const cleanedValue = !isEmpty(input) ? input.trim() : null;
      setSearchVariables((oldVariables) => ({
        ...oldVariables,
        keyword: cleanedValue,
        preventScroll: true,
      }));

      if (onChange) {
        onChange(cleanedValue);
      }
    },
    [setSearchVariables, onChange],
  );

  const debouncedSetSearchVariables = useDebouncedCallback(
    setSearchVariablesCallback,
    500,
    true,
  );

  return (
    <SearchBar
      className={className}
      inputContainerClassName={inputContainerClassName}
      value={value}
      placeholder={placeholder}
      onChange={(value) => debouncedSetSearchVariables(value)}
      onClear={() =>
        setSearchVariables((oldVariables) => ({
          ...oldVariables,
          keyword: '',
        }))
      }
      onFocus={onFocus}
    />
  );
};

export default SRPSearchBar;
